import React from 'react';
import { PrinterIcon } from '../icons/LucideIcons';

/**
 * The receipt printer and cash drawer, online or offline (from the print
 * client's heartbeat; hooks/useReceiptPrinterStatus). Nothing for a shop
 * that has never set one up, like the sidebar's printer pill.
 */
export default function ReceiptPrinterStatus({ status, className = '' }) {
  if (!status || !status.setUp) return null;
  const online = status.online;
  const text = !online
    ? 'Receipt printer offline. Check that the print client is running.'
    : status.cashDrawer ? 'Receipt printer and cash drawer online' : 'Receipt printer online';
  return (
    <span className={`inline-flex items-center gap-2 text-[13px] ${online ? 'text-gray-600' : 'text-danger-fg'} ${className}`} role="status" data-testid="receipt-printer-status">
      <span className="relative flex-shrink-0">
        <PrinterIcon size={16} />
        <span className={`absolute -right-0.5 -top-0.5 h-2 w-2 rounded-full ring-2 ring-white ${online ? 'bg-dot-ok' : 'bg-dot-red'}`} aria-hidden="true" />
      </span>
      {text}
    </span>
  );
}
